import {msg} from "@/i18n/Message.ts";

export function priceWithVat(amount, amountVat, symbol = null) {
	let txt = amount;
	if (amount !== amountVat) txt = txt + " " + msg("buscase.withVat") + " " + amountVat;
	if (symbol) txt = txt + " " + symbol;
	return txt;
}

export function valueOrDefault(val, def) {
	return typeof val === 'undefined' || val === null ? def : val;
}

export function getSuffix(value)
{	
	switch(value) {
	  case "application/xml":
		return ".xml";
	  case "application/json":
		return ".json";
	  case "text/css":
		return ".css";
	 case "text/plain":
		return ".txt";
	 case "text/javascript":
		return ".js";
	  default:
		return ".html";
	}
}

export function escapeSelectorJS(selector)
{
    if (selector) {
        return selector.replace("<", "-_").replace(">","_-").replace("@","__").replace(".","_");
    }

    return selector;
}

/**
 * Check if the birth number is valid for the country and return validation result and optionally gender
 * in simple object:
 * { valid: true/false, gender: code }
 */
export function validateBirthNumber(bn, country)
{
	let r = {};
	r.valid = true;
	r.gender = 0;	// unknown
	if ("CZ" !== country && "SK" !== country) return r;	// unsupported countries => valid

	bn = StrUtil.onlyTheseChars(bn, '0123456789');

	let genderVal = 0;
	if(bn.length === 9) {
		let fDD = parseInt(bn.substring(0,2)); //firstDoubleDigits
		if(fDD >= 54) r.valid = false;

		if(r.valid) {
			let sDD = parseInt(bn.substring(2,4)); //secondDoubleDigits
			if (sDD>=1 && sDD<=12) r.gender = 1;	// male
			else if (sDD >= 51 && sDD <= 62) r.gender = 2;	// female
			else r.valid = false;
		}
	} else if(bn.length===10) {
		let base = parseInt(bn);
		if(base % 11 > 0) r.valid = false; // modulo

		if(r.valid) {
			let sDD = bn.substring(2,4); //secondDoubleDigits
			if ((sDD>=1 && sDD<=12) || (sDD>=21 && sDD<=32)) r.gender = 1;
			else if ((sDD >= 51 && sDD <= 62) || (sDD>=71 && sDD<=82)) r.gender = 2;	// female
			else r.valid = false;
		}
	} else r.valid = false;
	return r;
}


export function id(elementId) { return document.getElementById(elementId); }
